const WinlosesTypes = {
    FETCH_START:    '[SERVERS][WINLOSES] FETCH START',
    FETCH_SUCCESS:  '[SERVERS][WINLOSES] FETCH SUCCESS',
    FETCH_FAILURE:  '[SERVERS][WINLOSES] FETCH FAILURE'
};

export default WinlosesTypes;